
<template>
  <div class="contact">
      <p class="ptitle">- Contact Us -</p>
      <p class="pt">For general information or inquiries concerning your order please contact us at:</p>
      <div class="line">
           <span>E:</span>
           <p class="p1">{{email}}</p>
           <span>T:</span>
           <p class="p2">{{tel}}</p>
      </div>
      <div class="fxbox">
          <div  v-for="item in follow" class="a2"  @click="go(item.path)" :key="item.name">
            
            <img :src="item.icon" alt="" class="icon">
          </div>
      </div>
      <div class="frombox">
          <input type="text" name="name" placeholder="Name" v-model="editForm.name" class="input1">
          <input type="text" name="email" placeholder="Email" v-model="editForm.email" class="input1">
          <input type="text" name="phone" placeholder="Phone" v-model="editForm.phone" class="input1">
          <textarea name="content" v-model="editForm.content" class="input2" placeholder="Type your message here..."></textarea>
          <div class="sbbtn" @click="send()">Submit</div>
      </div>
      <img :src="bgimg" alt="" class="dhua">
  </div>
</template>

<script>
import { settings,guestBook} from '../../api/userMG'


export default {
 name:'contact',
 data() {
   return {
    email:'',
    tel:'',
    sendok:false,
      bgimg:require("@/assets/img/hua2.png"),
       webname:'nomomo',
     webkey:'激光脫毛</br>​激光祛斑祛印',
     follow:[
     {
        name:'whatsapp',
        path:'',
        icon:require("@/assets/img/whatsapp.png")
      },
      {
        name:'ins',
        path:'',
        icon:require("@/assets/img/ins.png")
      }
     ],
    
     editForm: {

      name: '',
      email:'',
      Phone:'',
      content:'',
      token: localStorage.getItem('logintoken')
    },
    rules: {
      name: [
        { required: true, message: '請輸入姓名', trigger: 'blur' }
      ],
      Phone: [
        { required: true, message: '請輸入手機號', trigger: 'blur' }
      ]
    },
    smsCountdown: 0, // 倒計時的秒數
      smsCountdownTimer: null // 倒計時的定時器
   }
 },
 // 註冊組件
 components: {


   
 },
 /**
  * 數據發生改變
  */

 /**
  * 創建完畢
  */
 created() {
  this.getdata('whatsapp')
  this.getdata('ins')
  this.getdata2('email')
  this.getdata2('tel')
 },
 mounted() {

},
 /**
  * 裏麵的方法隻有被調用才會執行
  */
 methods: {
  go(url){
   
  
   window.open(url, '_blank');
 },
 getdata(parameter) {

  
  

settings(parameter)
.then(res => {
  this.loading = false

  if (res.data.code != 1) {
    this.$message({
      type: 'info',
      message: res.message
    })
  } else {
      let dd=res.data.data.data
    if(dd.length>0){
      let path=JSON.parse(dd[0].content)['val']

      this.follow.forEach(el=>{
         if(el.name==dd[0].name){
          el.path=path
         }

      })
   
    }
 
     
  }
})
.catch(err => {
  this.loading = false
  this.$message.error('菜單加載失敗，請稍後再試！')
})
},
getdata2(parameter) {

  
  

settings(parameter)
.then(res => {
  this.loading = false

  if (res.data.code != 1) {
    this.$message({
      type: 'info',
      message: res.message
    })
  } else {
      let dd=res.data.data.data
    if(dd.length>0){
      let path=JSON.parse(dd[0].content)['val']

      this[parameter]=path
   
    }
 
     
  }
})
.catch(err => {
  this.loading = false
  this.$message.error('菜單加載失敗，請稍後再試！')
})
},
 validateHKPhoneNumber(phoneNumber) {
    // 正则表达式匹配香港本地手机号码格式
    const localPattern = /^(5|6|7|8|9)\d{7}$/;
    // 正则表达式匹配香港国际手机号码格式
    const internationalPattern = /^\+852\d{8}$/;

    // 判断是否匹配本地或国际格式
    if (localPattern.test(phoneNumber) || internationalPattern.test(phoneNumber)) {
        return true; // 是有效的香港手机号码
    } else {
        return false; // 不是有效的香港手机号码
    }
},
  send(){
  
   if(this.sendok == true){
    return false
   }
  
   
    if(this.editForm.name==''){
    this.$message.error('請輸入姓名！')

    return false
   }

     const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!emailPattern.test(this.editForm.email)) {
        this.$message.error('請輸入有效的郵箱地址！');
        return false;
    }

   if(!this.validateHKPhoneNumber(this.editForm.phone)){
    this.$message.error('請輸入有效的聯係方式！')
    return false
     }
     if(this.editForm.content==''){
    this.$message.error('請輸入內容！')
    return false
     }
     this.loading = true
     this.sendok=true
    guestBook(this.editForm)
     .then(res => {
     
       this.loading = false
       if(res.code==1){
        this.$message({
             type: 'success',
             message: '留言成功！'
           })
       }
       this.smsCountdown = 5; // 假設倒計時60秒
      this.smsCountdownTimer = setInterval(() => {
        if (this.smsCountdown > 0) {
          this.smsCountdown -= 1;
        } else {
          this.sendok=false
          clearInterval(this.smsCountdownTimer);
        }
      }, 1000);
     })
     .catch(err => {
      this.sendok=false
       this.loading = false
       this.$message.error('發送失敗！')
     })
   
  }

  
 }
}
</script>

<style>
.wow { visibility: hidden; }
</style>




// WEBPACK FOOTER //
// src/views/home/contact.vue